var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpidIdpEtnaidbHpXwvSi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 497.18 115.91",
    style: {
      enableBackground: "new 0 0 497.18 115.91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#232047}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.14 79.03c.08-8.58 5.73-14.88 12.58-16.73 2.01-.54 4.05-.76 6.12-.51 1.19.14 2.39.21 3.59.17 4.37-.14 8.35-1.48 11.91-4.01 1.07-.76 2.05-1.64 2.98-2.57.88-.89 1.72-1.8 2.46-2.81 2.04-2.76 3.34-5.84 3.94-9.22.4-2.25.42-4.51.13-6.77-.17-1.36-.12-2.72.07-4.06.39-2.76 1.37-5.29 3-7.56 2.62-3.66 6.13-6 10.54-6.88 7.52-1.49 14.69 2.11 18.22 8.51a16.6 16.6 0 0 1 2.07 7.04c.33 5.14-1.26 9.6-4.83 13.3-2.51 2.6-5.58 4.21-9.14 4.85-1.64.3-3.28.33-4.94.16-5.03-.51-9.73.45-14.05 3.13-1.49.92-2.83 2.03-4.06 3.28-.73.75-1.45 1.49-2.1 2.31-2.29 2.9-3.74 6.18-4.38 9.82-.34 1.93-.41 3.87-.22 5.82.16 1.56.23 3.12.03 4.68-.33 2.48-1.1 4.8-2.43 6.93-2.53 4.06-6.13 6.68-10.8 7.73-5.96 1.34-12.02-.64-16.09-5.03-2.4-2.6-3.87-5.65-4.4-9.16-.12-.87-.16-1.73-.2-2.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.311,
    y1: 78.595,
    x2: 97.065,
    y2: 78.595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5ac28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eb752a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 79.69,
    cy: 78.6,
    r: 17.38,
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143616047899482958750000007232680994048206475_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.047,
    y1: 35.331,
    x2: 53.801,
    y2: 35.331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5ac28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eb752a"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000143616047899482958750000007232680994048206475_)"
    },
    cx: 36.42,
    cy: 35.33,
    r: 17.38
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.83 31.89c14.23 0 33.4 10.69 30.5 36.83h-49.55c1.93 10.57 10.13 16.39 20.62 16.39 6.63 0 12.42-1.9 17.36-5.7l7.35 6.89c-5.91 6.53-14.23 9.74-25.08 9.74-5.43 0-10.61-1.07-15.55-3.33C121.71 88.08 114 77.74 114 64.08c0-10.33 4.34-19.13 10.61-24.23 6.39-5.11 13.98-7.96 21.22-7.96zm0 11.05c-8.68 0-17 5.94-18.93 16.27h37.74c-.6-5.11-2.77-9.15-6.51-12-3.74-2.85-7.84-4.27-12.3-4.27zM218.29 33.55v10.69h-13.26v34.57c0 3.92 1.93 5.82 5.91 5.82 2.29 0 4.7-.47 7.35-1.43v10.57c-3.01 1.54-6.63 2.26-10.85 2.26-9.65 0-15.43-3.8-15.43-14.37V44.24h-8.68V33.55h8.68v-15.8h13.02v15.8h13.26zM263.75 33.08c6.51 0 12.06 2.26 16.64 6.89s6.87 11.4 6.87 20.31v35.76h-13.02V60.99c0-11.05-6.27-16.63-14.95-16.63-4.82 0-8.8 1.66-11.94 4.99-3.01 3.21-4.82 6.53-5.18 9.74v36.94h-13.02V34.27h13.02V47.1c1.32-3.57 7.83-14.02 21.58-14.02zM328.02 96.04c-7.23 0-14.71-2.73-20.86-7.84-6.15-5.11-10.25-13.9-10.25-24.23s4.1-19.13 10.25-24.23c6.15-5.11 13.62-7.84 20.86-7.84 10.01 0 17.96 5.46 20.86 11.29h.72v-10.1h13.02v61.77H349.6v-10.1h-.72c-2.9 5.81-10.86 11.28-20.86 11.28zm1.68-11.41c5.43 0 10.13-1.78 14.11-5.46 4.1-3.68 6.15-8.67 6.15-15.21 0-6.53-2.05-11.52-6.15-15.21-3.98-3.68-8.68-5.46-14.11-5.46-5.3 0-10.01 1.78-14.11 5.46-3.98 3.68-6.03 8.67-6.03 15.21 0 6.53 2.05 11.52 6.03 15.21 4.11 3.68 8.81 5.46 14.11 5.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174564669243997489670000010594038130461497732_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.271,
    y1: 56.895,
    x2: 395.843,
    y2: 56.895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5ac28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eb752a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174564669243997489670000010594038130461497732_)"
    },
    d: "M379.27 17.75h16.57v78.28h-16.57V17.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152242750934432597500000015354428214167774133_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.465,
    y1: 56.895,
    x2: 478.138,
    y2: 56.895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5ac28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eb752a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152242750934432597500000015354428214167774133_)"
    },
    d: "M409.47 17.75h28.38c11.24 0 20.77 3.8 28.6 11.41 7.83 7.49 11.69 16.66 11.69 27.29 0 11.07-3.86 20.47-11.69 28.18-7.83 7.61-17.37 11.41-28.6 11.41h-28.38V17.75zm16.57 62.85h11.69c7.38 0 13.05-2.24 17.14-6.82 4.2-4.58 6.24-10.4 6.24-17.33 0-6.6-2.04-12.08-6.24-16.55-4.2-4.47-9.87-6.71-17.14-6.71h-11.69V80.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpidIdpEtnaidbHpXwvSi);
export default __webpack_public_path__ + "static/media/spid-idp-etnaid~bHPXwvSi.d4ff86323bf775f22cfb46ba8b6b62c4.svg";
export { ForwardRef as ReactComponent };